const getRutNumber = rut => String(rut ?? '').split('-')[0].replace(/\D/g, '')

export const getDocumentPdfKey = row => `${row?.query}:${getRutNumber(row?.rut)}:${row?.numeroFolio}`

export const getDocumentPdfLookup = row => ({
  query: row.query,
  folio: row.numeroFolio,
  rut: row.rut
})
